"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiFormGroupOverrides = void 0;
var createMuiFormGroupOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            "[class*='MuiFormLabel-root'] + &": {
                marginTop: spacing(2),
            },
        },
    });
};
exports.createMuiFormGroupOverrides = createMuiFormGroupOverrides;
//# sourceMappingURL=MuiFormGroup.js.map